import { useMediaQuery } from "@mui/material"
import Web from "./Web"
import Mob from "./Mobile"
export default function Pricing() {
    const isSmallScreen = useMediaQuery("(max-width:960px")
    return isSmallScreen ? <Mob/> : <Web/>
}